export const atolCertificateQueryKeys = {
  all: ['atol-certificates'] as const,
  details: () => [...atolCertificateQueryKeys.all, 'detail'] as const,
  detail: (id: string) => [...atolCertificateQueryKeys.details(), id] as const,
  byOrder: (orderId: string) => [...atolCertificateQueryKeys.all, 'byOrder', orderId] as const,
  byCustomer: (customerId: string) => [...atolCertificateQueryKeys.all, 'byCustomer', customerId] as const,
};
